// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34Q8M","badges":"styles_badges__2HgFS"};